import { Security } from "./types";

const initialState = {
    bans: [],
    allowlist: [],
    loading: false,
    error: null,
};

export default function securityReducer(state = initialState, action) {
    switch (action.type) {
        case Security.SET_LOADING:
            return { ...state, loading: action.loading };
        case Security.SET_BANS:
            return { ...state, bans: action.bans, error: null };
        case Security.SET_ALLOWLIST:
            return { ...state, allowlist: action.entries, error: null };
        case Security.SET_ERROR:
            return { ...state, error: action.error };
        default:
            return state;
    }
}
